import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';

interface OverlayProps {
    open: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    onConfirm?: () => void;
    confirmText?: string;
}

const Overlay: React.FC<OverlayProps> = ({ open, onClose, title, children, onConfirm, confirmText }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" sx={{ backgroundColor: 'blue', '&:hover': { backgroundColor: 'darkblue' } }}>
                    Cancel
                </Button>
                {onConfirm && (
                    <Button
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                        variant="contained"
                        sx={{ backgroundColor: 'green', '&:hover': { backgroundColor: 'darkgreen' } }}
                    >
                        {confirmText || 'Confirm'}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default Overlay;
